export default "__VITE_ASSET__DQwMMnEv__"